import React from 'react';
import './RadioOption.css';

interface RadioOptionProps {
  /** Radio group name — give every option in a group the same name. */
  name: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  label: React.ReactNode;
  /** Optional secondary line (guidance, price). */
  description?: React.ReactNode;
  /** Optional leading icon (e.g. a device-type glyph). */
  icon?: React.ReactNode;
  disabled?: boolean;
}

/**
 * A single design-system radio-option box (sm4rt-web-ui §12) — a bordered pill
 * that tints blue when selected. Use for single-select "pick one" toggles on
 * forms instead of MUI `RadioGroup`/`FormControlLabel`. Group several inside a
 * `.radio-option-group` (add `--row` to lay them out horizontally).
 */
export const RadioOption: React.FC<RadioOptionProps> = ({
  name,
  value,
  checked,
  onChange,
  label,
  description,
  icon,
  disabled,
}) => (
  <label
    className={`radio-option ${checked ? 'radio-option--selected' : ''} ${
      disabled ? 'radio-option--disabled' : ''
    }`}
  >
    <input
      type="radio"
      name={name}
      value={value}
      checked={checked}
      disabled={disabled}
      onChange={() => onChange(value)}
    />
    {icon && <span className="radio-option__icon">{icon}</span>}
    <span className="radio-option__text">
      <span className="radio-option__label">{label}</span>
      {description && <span className="radio-option__desc">{description}</span>}
    </span>
  </label>
);
